module.exports = __webpack_public_path__ + "media/img/pages/profile/uni basel ger 2-dce686e5272d5de4c0e40b9b80a167ec.jpg";